<template>
  <div
    class="bio-upgrade-banner d-flex flex-column flex-md-row justify-content-center justify-content-md-start align-items-center align-items-md-start flex-no-wrap"
  >
    <div class="mr-3">
      <img src="/assets/images/bio-upgrade-poster.png" width="205px" />
    </div>
    <div class="d-flex flex-grow-1 flex-column justify-content-start">
      <div class="text mt-2">
        {{ $t('BIO.TEXT.BANNER_UPGRADE_TITLE') }}
      </div>
      <div class="description mt-2 smaller">
        <div class="mb-2">
          Unlock so many more features on the world’s most beautiful all-in-one
          teaching platform.
        </div>
        <ul>
          <li class="mb-2">
            Livestreaming, unlimited online products, and on-demand library
          </li>
          <li class="mb-2">
            Built-in community to move your memberships off Facebook
          </li>
          <li class="mb-2">
            Brand your studio in minutes, and integrate with your favorite
            platforms
          </li>
          <li>
            Premium Marvelous.bio features including no Tip jar commission fees
          </li>
        </ul>
      </div>
      <HMButton class="mt-4" color="brand" @click="goToUpgrade">
        {{ $t('BIO.BUTTON.LETS_GO') }}
      </HMButton>
    </div>
    <div class="close-btn text-right mt-2">
      <font-awesome-icon
        class="close-icon pointer"
        :icon="['far', 'times']"
        @click="hide"
      />
    </div>
    <div class="watermark">
      <img
        src="/assets/images/make-it-marvelous-submark-coral.png"
        width="120px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BioUpgradeBanner',
  methods: {
    goToUpgrade() {
      this.$router.push({ name: 'bio-upgrade' });
    },
    hide() {
      this.$store.dispatch('globals/setShowBioUpgrade', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.bio-upgrade-banner {
  position: relative;
  padding: 1rem 2rem;
  background-color: lighten($coral, 30%);
  border-radius: 10px;

  .text {
    font-weight: 600;
    color: $black;
  }

  .description {
    color: $black;
  }

  button {
    width: fit-content;
  }

  ul {
    padding: 0 0 0 1rem;
  }

  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 1rem 2rem;
  }

  .watermark {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 1rem;
  }
}
</style>
